import React from 'react'
import { ICalls } from '@dataTypes/calls.type'
import { CALL_TYPES_ICON } from '@constants/Message'
import {
  getCallAiPlaceholder,
  getCallDisplayType,
  getCallDisplayTooltip,
} from '@utils/call.util'

export const typeTemplate = (props: ICalls): JSX.Element => {
  const type = getCallDisplayType(props)
  return (
    <div className="d-flex justify-content-center align-items-center">
      <span
        className={`call-type-icon ${type.toLowerCase()} ${CALL_TYPES_ICON[type]}`}
        data-bs-toggle="tooltip"
        title={getCallDisplayTooltip(props)}
        role="img"
        aria-label={getCallDisplayTooltip(props)}
      />
    </div>
  )
}

export const sentimentsTemplate = (props: ICalls): JSX.Element => {
  const sentiment = props.sentiments?.trim()
  const label = sentiment || getCallAiPlaceholder(props)
  const isAnalyzing = !sentiment && label === 'Analyzing...'
  return (
    <div className="d-flex justify-content-start align-items-center">
      <span
        className={
          isAnalyzing
            ? 'call-ai-placeholder'
            : `call-sentiment ${sentiment ? sentiment.toLowerCase() : ''}`
        }
      >
        {label}
      </span>
    </div>
  )
}
